import axios from "./axios";

export const billingPlanItemsApi = {
  getBillingPlanItems: (projectId, params = {}) => {
    return axios.get(`/projects/${projectId}/billing_plan_items`, { params });
  },

  getBillingPlanItem: (projectId, billingPlanItemId, params = {}) => {
    return axios.get(`/projects/${projectId}/billing_plan_items/${billingPlanItemId}`, { params });
  },

  createBillingPlanItem: (projectId, billingPlanItem) => {
    return axios.post(`/projects/${projectId}/billing_plan_items`, {
      billing_plan_item: billingPlanItem,
    });
  },

  updateBillingPlanItem: (projectId, billingPlanItemId, billingPlanItem) => {
    return axios.put(`/projects/${projectId}/billing_plan_items/${billingPlanItemId}`, {
      billing_plan_item: billingPlanItem,
    });
  },

  deleteBillingPlanItem: (projectId, billingPlanItemId) => {
    return axios.delete(`/projects/${projectId}/billing_plan_items/${billingPlanItemId}`);
  },

  invoiceBillingPlanItem: (projectId, billingPlanItemId, params = {}) => {
    return axios.post(`/projects/${projectId}/billing_plan_items/${billingPlanItemId}/invoice`, params);
  },

  exportBillingPlanItems: (projectId, format = "pdf") => {
    return axios.get(`/projects/${projectId}/billing_plan_items/export`, {
      params: { format },
      responseType: "blob",
    });
  },

  exportBillingAttachment: (projectId, settings = {}) => {
    return axios.get(`/projects/${projectId}/billing_plan_items/billing_attachment`, {
      params: settings,
      responseType: "blob",
    });
  },
};

